import {Box, Chip, Grid, Link, Stack, Typography} from '@mui/material';
import {Clear} from '@mui/icons-material';
import PopUp from 'components/PopUp/PopUp';
import {CheckboxFilter} from 'components/CheckboxFilter/CheckboxFilter';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectAllReleases} from 'app/store/change/changeSlice';
import {selectSelectedReleases, setSelectedReleases} from 'app/store/appState/appStateSlice';

const ReleaseSelector = () => {
  const selectedReleases = useSelector(selectSelectedReleases);
  const allReleases = useSelector(selectAllReleases);
  const [openPopUp, setOpenPopUp] = React.useState(false);
  const [releaseState, setReleaseState] = React.useState<Array<string>>(selectedReleases);
  const dispatch = useDispatch();

  const handleDelete = (release: string) => {
    const arr = releaseState.filter((x) => x !== release);
    setReleaseState(arr);
    dispatch(setSelectedReleases(arr));
  };

  const formatDate = (date?: string) => {
    const month = date?.substring(4, 6);

    function getMonthName(month?: string) {
      if (month) {
        const monthNumber = parseInt(month);
        const date = new Date();
        date.setMonth(monthNumber - 1);

        return date.toLocaleString('en-US', {month: 'short'});
      }
    }

    const day = date?.substring(6, 8);
    return `(${getMonthName(month)?.toUpperCase()} ${day})`;
  };

  const getReleaseKeyVal = () => {
    const releases = allReleases.reduce((acc, curr) => {
      acc.push({key: curr.release, value: formatDate(curr.created_dt)});
      return acc;
    }, [] as Array<{key: string; value: string}>);

    return releases;
  };

  return (
    <Box>
      <Stack direction='row' alignItems='center' spacing={2}>
        <Typography variant='h6' fontSize={16}>
          Include the Folowing Releases
        </Typography>
        <Link color='primary' underline='hover' onClick={() => setOpenPopUp(true)}>
          {`Add Release(s)`}
        </Link>
      </Stack>
      <PopUp
        title='Add Release(s)'
        onConfirm={() => {
          setOpenPopUp(false);
          dispatch(setSelectedReleases(releaseState));
        }}
        open={openPopUp}
        onCancel={() => {
          setOpenPopUp(false);
          setSelectedReleases(selectedReleases);
        }}
        maxWidth='sm'
      >
        <CheckboxFilter
          title='Choose which releases you’d like to include in your updates.'
          choices={getReleaseKeyVal()}
          selected={releaseState}
          callback={setReleaseState}
        />
      </PopUp>
      <Grid container rowGap={2} columnGap={2} my={2}>
        {selectedReleases?.map((release) => (
          <Grid item xs='auto' key={`Release-Chip-${release}`}>
            <Chip
              label={release + ' ' + formatDate(allReleases.find((r) => r.release === release)?.created_dt)}
              onDelete={() => handleDelete(release)}
              deleteIcon={<Clear sx={{color: 'grey.800'}} />}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
export default ReleaseSelector;

// ?.sort((a: string, b: string) => {
//   const getVersionPart = (version: string, index: number) => {
//     return parseInt(version.split('.')[index], 10) || 0;
//   };

//   const aYear = getVersionPart(a, 0);
//   const bYear = getVersionPart(b, 0);

//   const aMonth = getVersionPart(a, 1);
//   const bMonth = getVersionPart(b, 1);

//   const aRevision = getVersionPart(a, 2);
//   const bRevision = getVersionPart(b, 2);

//   if (aYear !== bYear) return bYear - aYear;
//   if (aMonth !== bMonth) return bMonth - aMonth;
//   return bRevision - aRevision;
// })
